import { render, staticRenderFns } from "./GChatRoundedButton.vue?vue&type=template&id=4425b8c1&scoped=true&"
import script from "./GChatRoundedButton.vue?vue&type=script&lang=ts&"
export * from "./GChatRoundedButton.vue?vue&type=script&lang=ts&"
import style0 from "./GChatRoundedButton.vue?vue&type=style&index=0&id=4425b8c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425b8c1",
  null
  
)

export default component.exports